import React, { useState } from "react";
import { Modal, Radio, Space, message } from "antd";
import useAxios from "../../utilities/useAxios";

const KIND_OPTIONS = [
	{ value: "정기휴무", label: "정기휴무" },
	{ value: "지각", label: "지각" },
	{ value: "일반출근", label: "일반출근" },
];

const AttendanceDayOverrideModal = ({
	open,
	target,
	onClose,
	onSaved,
}) => {
	const [kind, setKind] = useState(target?.kind || "일반출근");
	const [saving, setSaving] = useState(false);

	React.useEffect(() => {
		if (open) {
			setKind(target?.kind || target?.override_kind || "일반출근");
		}
	}, [open, target]);

	const save = async () => {
		if (!target?.user_id || !target?.date) return;
		try {
			setSaving(true);
			await useAxios.post("/attendance/day-override/", {
				user_id: target.user_id,
				date: target.date,
				kind,
			});
			message.success("표시를 변경했습니다.");
			onSaved?.();
			onClose?.();
		} catch (error) {
			message.error(
				error?.response?.data?.error || "표시 변경에 실패했습니다.",
			);
		} finally {
			setSaving(false);
		}
	};

	return (
		<Modal
			title={`${target?.name || ""} — ${target?.date || ""} 표시 변경`}
			open={open}
			onCancel={onClose}
			onOk={save}
			confirmLoading={saving}
			okText="저장"
			destroyOnClose>
			<Radio.Group
				value={kind}
				onChange={(e) => setKind(e.target.value)}
				optionType="button"
				buttonStyle="solid">
				<Space wrap>
					{KIND_OPTIONS.map((opt) => (
						<Radio.Button key={opt.value} value={opt.value}>
							{opt.label}
						</Radio.Button>
					))}
				</Space>
			</Radio.Group>
		</Modal>
	);
};

export default AttendanceDayOverrideModal;
